<div>
  <button
    matSuffix
    mat-icon-button
    color="primary"
    aria-label="add library"
    i18n-aria-label="@@addLibraryAriaLabel"
    matTooltip="Create a new profile"
    i18n-matTooltip="@@createNewProfileTooltip"
    (click)="onOpenNewLibraryDialog()"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="1000"
  >
    <mat-icon>add</mat-icon>
  </button>
</div>
